import { QueryClient } from '@tanstack/react-query'
import type { Session } from '@/api/models/UserModel'

export const USER_SESSION_QUERY_KEY = 'session'

export const queryClient = new QueryClient()

export function clearStoredUserSession(): void {
  // TanStack Query treats `undefined` as "no update"; null clears cached session data.
  queryClient.setQueryData<Session | null>([USER_SESSION_QUERY_KEY], null)
}
